import { render, staticRenderFns } from "./EditFieldHeader.vue?vue&type=template&id=10c894b0&scoped=true&"
import script from "./EditFieldHeader.vue?vue&type=script&lang=js&"
export * from "./EditFieldHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c894b0",
  null
  
)

export default component.exports